/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AuthCsrfToken$Params {
}

export function authCsrfToken(http: HttpClient, rootUrl: string, params?: AuthCsrfToken$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Status of the CSRF token retrieval operation
 */
'status'?: 'success';
}>> {
  const rb = new RequestBuilder(rootUrl, authCsrfToken.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * Status of the CSRF token retrieval operation
       */
      'status'?: 'success';
      }>;
    })
  );
}

authCsrfToken.PATH = '/auth/csrfToken';
